import Loader from "../../components/Loader";
import {useQuery} from "@tanstack/react-query";
import {useContext, useEffect, useState} from "react";
import Paginator from "../../components/Paginator";
import {
    Col,
    Form,
    FormFeedback,
    Row,
    Input,
    Label,
    Button,
    AccordionItem,
    AccordionHeader,
    AccordionBody, Accordion, UncontrolledAccordion
} from "reactstrap";
import AuthContext from "../../context/AuthContext";
import handleUnauthorized401QueryError from "../../utils/handleUnauthorized401QueryError";
import {getTransactions} from "../../api/api";
import {toast} from "react-toastify";
import Transaction from "./Transaction";
import RecordsNotFound from "../../components/RecordsNotFound";
import {useLocation, useNavigate} from "react-router-dom";


function TransactionPage() {
    const {refreshToken, user} = useContext(AuthContext)
    const location = useLocation();
    const orderFromState = location.state?.order || "";
    const [page, setPage] = useState(1);
    const [transactionId, setTransactionId] = useState("");
    const [order, setOrder] = useState(orderFromState);
    // const [referenceTransactionId, setReferenceTransactionId] = useState("");
    const [transactionStatus, setTransactionStatus] = useState("");
    const [amount, setAmount] = useState("");
    const [currency, setCurrency] = useState("");
    const [paymentMode, setPaymentMode] = useState("");
    // const [bankUTR, setBankUTR] = useState("");
    // const [remitterAccountNumber, setRemitterAccountNumber] = useState("");
    // const [remitterAccountIFSC, setRemitterAccountIFSC] = useState("");
    // const [remitterAccountType, setRemitterAccountType] = useState("");
    // const [remitterUPIHandle, setRemitterUPIHandle] = useState("");
    // const [remitterFullName, setRemitterFullName] = useState("");
    // const [remitterPhoneNumber, setRemitterPhoneNumber] = useState("");
    // const [serviceCharge, setServiceCharge] = useState("");
    // const [GSTAmount, setGSTAmount] = useState("");
    // const [serviceChargeWithGST, setServiceChargeWithGST] = useState("");
    const [created, setCreated] = useState("");
    const [updated, setUpdated] = useState("")

    const [queryKey, setQueryKey] = useState(['transactions', page])
    const [openAdvancedSearch, setOpenAdvancedSearch] = useState(false);

    const [isAdvancedSearchDisabled, setIsAdvancedSearchDisabled] = useState(false);
    const [isTransactionURLDisabled, setIsTransactionURLDisabled] = useState(false);
    const navigate = useNavigate()

    const toggleAdvancedSearch = () => setOpenAdvancedSearch((prevState) => !prevState);

    useEffect(() => {
        setQueryKey(['transactions', page])
    }, [page]);

    useEffect(() => {
        if (!orderFromState) return;
        setPage(1);
        setTransactionId('');
        setOrder(orderFromState);
        setTransactionStatus('');
        setAmount('');
        setCurrency('');
        setPaymentMode('');
        setCreated('');
        setUpdated('');
        setQueryKey(['transactions', 1, '', orderFromState, '', '', '', '', '', '']);
    }, [orderFromState]);

    useEffect(() => {
        if (
            transactionId === '' && order === '' && transactionStatus === '' && amount === '' && currency === ''
            && paymentMode === '' && created === ''  && updated === ''
        ) {
            clearSearchTransaction();
        }
    }, [
        transactionId, order, transactionStatus, amount, currency, paymentMode, created, updated
    ]);


    const { status, data, error, isFetching, refetch } = useQuery({
        queryKey: queryKey,
        queryFn: () => getTransactions(page, transactionId, order, transactionStatus,
            amount, currency, paymentMode, created, updated),
        keepPreviousData : true,
        retry: false,
        onError: (err => {
            handleUnauthorized401QueryError(err, refreshToken, refetch)
            if(err.response.status !== 401){
                toast.error(`An error occurred! ${err?.response?.data?.detail}`)
            }
            if(err.response.status === 403){
                navigate(-1)
            }
        })
        })

    const searchTransaction = (e) =>{
        e.preventDefault()
        setPage(1)
        setQueryKey( ['transactions', page, transactionId, order, transactionStatus,
            amount, currency, paymentMode, created, updated])
    }

    const clearSearchTransaction = (e) =>{
        e?.preventDefault()
        setTransactionId('')
        setOrder('')
        // setReferenceTransactionId('')
        setTransactionStatus('')
        setAmount('')
        setCurrency('')
        setPaymentMode('')
        // setBankUTR('')
        // setRemitterAccountNumber('')
        // setRemitterAccountIFSC('')
        // setRemitterAccountType('')
        // setRemitterUPIHandle('')
        // setRemitterFullName('')
        // setRemitterPhoneNumber('')
        // setServiceCharge('')
        // setGSTAmount('')
        // setServiceChargeWithGST('')
        setCreated('')
        setUpdated('')
        setQueryKey( ['transactions', 1])
        // setPage(1)
    }

    return (
        <>
            <UncontrolledAccordion defaultOpen="" flush={true}>
                <AccordionItem>
                    <AccordionHeader targetId="1">
                        <span><i className="mdi mdi-filter"/></span>
                    </AccordionHeader>
                    <AccordionBody accordionId="1">
                        <div className="card-box">
                            <div className="row">
                                <div className="col-sm-12">
                                    <Form onSubmit={searchTransaction}>
                                        <Row className="form-row align-items-center">
                                            <Col>
                                                <Label
                                                    className="visually-hidden"
                                                    for="order"
                                                >
                                                    Order ID
                                                </Label>
                                                <Input
                                                    id="order"
                                                    name="order"
                                                    type="text"
                                                    className="form-control mb-2"
                                                    onChange={(e) =>
                                                        setOrder(
                                                            e.target.value
                                                        )
                                                    }
                                                    value={order}
                                                    invalid={
                                                        error && error.response.data.order
                                                    }
                                                />
                                                <FormFeedback invalid>
                                                    {error && error.response.data.order}
                                                </FormFeedback>
                                            </Col>
                                            <Col>
                                                <Label
                                                    className="visually-hidden"
                                                    for="transaction_id"
                                                >
                                                    Transaction ID
                                                </Label>
                                                <Input
                                                    id="transaction_id"
                                                    name="transaction_id"
                                                    type="text"
                                                    className="form-control mb-2"
                                                    onChange={(e) =>
                                                        setTransactionId(
                                                            e.target.value
                                                        )
                                                    }
                                                    value={transactionId}
                                                    invalid={
                                                        error && error.response.data.id
                                                    }
                                                />
                                                <FormFeedback invalid>
                                                    {error && error.response.data.id}
                                                </FormFeedback>
                                            </Col>
                                            <Col>
                                                <Label
                                                    className="visually-hidden"
                                                    for="price"
                                                >
                                                    Amount
                                                </Label>
                                                <Input
                                                    id="amount"
                                                    name="amount"
                                                    type="text"
                                                    className="form-control mb-2"
                                                    onChange={(e) =>
                                                        setAmount(
                                                            e.target.value
                                                        )
                                                    }
                                                    value={amount}
                                                    invalid={
                                                        error && error.response.data.amount
                                                    }
                                                />
                                                <FormFeedback invalid>
                                                    {error && error.response.data.amount}
                                                </FormFeedback>
                                            </Col>
                                            <Col>
                                                <Label
                                                    className="visually-hidden"
                                                    for="currency"
                                                >
                                                    Currency
                                                </Label>
                                                <Input
                                                    type="select"
                                                    id="inputState"
                                                    className="form-control mb-2"
                                                    value={currency}
                                                    onChange={(e) =>
                                                        setCurrency(
                                                            e.target.value
                                                        )
                                                    }
                                                >
                                                    <option value="">--</option>
                                                    <option value={"INR"}>
                                                        INR
                                                    </option>
                                                    <option value={"USD"}>
                                                        USD
                                                    </option>
                                                </Input>
                                                {/*<FormFeedback invalid>*/}
                                                {/*    {error && error.response.data.description}*/}
                                                {/*</FormFeedback>*/}
                                            </Col>
                                            <Col>
                                                <Label
                                                    className="visually-hidden"
                                                    for="date-created"
                                                >
                                                    Date Created
                                                </Label>
                                                <Input
                                                    id="date-created"
                                                    name="date-created"
                                                    type="date"
                                                    className="form-control mb-2"
                                                    onChange={(e) =>
                                                        setCreated(
                                                            e.target.value
                                                        )
                                                    }
                                                    value={created}
                                                    invalid={
                                                        error && error.response.data.created
                                                    }
                                                />
                                                <FormFeedback invalid>
                                                    {error && error.response.data.created}
                                                </FormFeedback>
                                            </Col>
                                        </Row>
                                        {!isAdvancedSearchDisabled && (
                                            <>
                                                <Row className="form-row align-items-center">
                                                    <Col>
                                                        <div className="form-check">
                                                            <Input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                id="advanced-search"
                                                                defaultChecked={openAdvancedSearch}
                                                                disabled={isAdvancedSearchDisabled}
                                                                onChange={() => toggleAdvancedSearch()}
                                                            />
                                                            <Label check className="form-check-label mb-2" for="advanced-search">
                                                                Advanced Search
                                                            </Label>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Accordion open={openAdvancedSearch}>
                                                    <AccordionItem>
                                                        <AccordionBody accordionId={true}>
                                                            <Row className="form-row align-items-center">
                                                                <Col>
                                                                    <Label className="visually-hidden" for="payment-method">Payment Method</Label>
                                                                    <Input
                                                                        id="payment-method"
                                                                        name="payment-method"
                                                                        type="text"
                                                                        className="form-control mb-2"
                                                                        onChange={(e) => setPaymentMode(e.target.value)}
                                                                        value={paymentMode}
                                                                        invalid={error && error.response.data.payment_method}
                                                                    />
                                                                    <FormFeedback invalid>{error && error.response.data.payment_method}</FormFeedback>
                                                                </Col>
                                                                <Col>
                                                                    <Label className="visually-hidden" for="date-updated">Date Updated</Label>
                                                                    <Input
                                                                        id="date-updated"
                                                                        name="date-updated"
                                                                        type="date"
                                                                        className="form-control mb-2"
                                                                        onChange={(e) => setUpdated(e.target.value)}
                                                                        value={updated}
                                                                        invalid={error && error.response.data.updated}
                                                                    />
                                                                    <FormFeedback invalid>{error && error.response.data.updated}</FormFeedback>
                                                                </Col>
                                                            </Row>
                                                        </AccordionBody>
                                                    </AccordionItem>
                                                </Accordion>
                                            </>
                                        )}
                                        <Row className="form-row align-items-center">
                                            {isAdvancedSearchDisabled && (
                                                <Col>
                                                    <Button
                                                        type="submit"
                                                        className="btn bx-btn-primary waves-effect waves-light mr-2"
                                                        disabled={!transactionId && !order && !amount && !currency && !created}
                                                    >
                                                        Search
                                                    </Button>
                                                    <Button
                                                        type="button"
                                                        onClick={clearSearchTransaction}
                                                        className="btn bx-btn-primary waves-effect waves-light"
                                                        disabled={!transactionId && !order && !amount && !currency && !created}
                                                    >
                                                        Clear
                                                    </Button>
                                                </Col>
                                            )}
                                            {!isAdvancedSearchDisabled && (
                                                <Col>
                                                    <Button
                                                        type="submit"
                                                        className="btn bx-btn-primary waves-effect waves-light mr-2"
                                                        disabled={!transactionId && !order &&
                                                            !transactionStatus && !amount && !currency && !paymentMode
                                                            && !created && !updated}
                                                    >
                                                        Search
                                                    </Button>
                                                    <Button
                                                        type="button"
                                                        onClick={clearSearchTransaction}
                                                        className="btn bx-btn-primary waves-effect waves-light"
                                                        disabled={!transactionId && !order &&
                                                            !transactionStatus && !amount && !currency && !paymentMode
                                                            && !created && !updated}
                                                    >
                                                        Clear
                                                    </Button>
                                                </Col>
                                            )}
                                        </Row>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </AccordionBody>
                </AccordionItem>
            </UncontrolledAccordion>

            {status === 'loading' && (
                <Loader size={'default'}/>
            )}

            {/*{status === 'error' && (*/}
            {/*    <p>Error...{error.response.status}</p>*/}
            {/*)}*/}

            {status === 'success' | error?.response?.status === 401 && (
                <div className="row">
                    <div className="col-12">



                        <div className="card-box">
                            <div className="table-responsive">
                                <table className="table table-centered mb-0">
                                    <thead className="font-13 bg-light text-muted">
                                    <tr>
                                        <th className="font-weight-medium">Transaction ID</th>
                                        <th className="font-weight-medium">Order Number</th>
                                        <th className="font-weight-medium">Amount</th>
                                        <th className="font-weight-medium">Currency</th>
                                        <th className="font-weight-medium">Payment Mode</th>
                                        <th className="font-weight-medium">Transaction Status</th>
                                        <th className="font-weight-medium text-center">Date created</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {data?.count > 0? data?.results?.map(transaction => (
                                        <Transaction key={transaction.id} transaction={transaction} isTransactionURLDisabled={isTransactionURLDisabled}/>
                                    )): <RecordsNotFound/>}
                                    </tbody>
                                </table>
                            </div>
                            {status === 'success' && (
                                <Paginator data={data} page={page} setPage={setPage} last={data?.last_page} loading={isFetching}/>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default TransactionPage;
